import React, { useEffect, useRef } from "react";
import { MdOutlineInfo } from "react-icons/md";
import "./SharedStyles.scss";

interface IProps {
  message: string;
}

const EAPageMessage: React.FC<IProps> = ({ message }) => {
  const articleRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!articleRef.current) return;

    const links = articleRef.current.querySelectorAll("a[href]");

    links.forEach((link) => {
      const anchor = link as HTMLAnchorElement;
      const href = anchor.getAttribute("href") || "";

      // Określ czy link jest wewnętrzny
      const isInternalLink =
        href.startsWith("/") || // Relatywny link
        href.startsWith("#") || // Link do sekcji na stronie
        href.startsWith("?") || // Query params
        (anchor.hostname && anchor.hostname === window.location.hostname); // Ta sama domena

      if (isInternalLink) {
        // Usuń target="_blank" dla linków wewnętrznych
        anchor.removeAttribute("target");
        anchor.removeAttribute("rel");
      } else {
        // Dla linków zewnętrznych upewnij się że mają bezpieczne atrybuty
        anchor.setAttribute("target", "_blank");
        anchor.setAttribute("rel", "noopener noreferrer");
      }
    });
  }, [message]);

  // Zabezpieczenie przed message, który ma tylko same znaczniki HTML
  if (message && message.length > 12) {
    return (
      <div className="page-message">
        <MdOutlineInfo className="page-message-icon" />
        <article ref={articleRef} dangerouslySetInnerHTML={{ __html: message }}></article>
      </div>
    );
  }

  return null;
};

export default EAPageMessage;
